// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__jV0-b","signatureButtonsRight":"ModalSign_signatureButtonsRight__aaqRE"};